import { ButtonIcon } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';

export const ResetButton = ({ handleClick }: { handleClick: () => void }) => {
  const { t } = useTranslation('filters');

  return (
    <ButtonIcon displayText="left" icon="Reset" variant="secondary" onClick={() => handleClick()} size="small">
      {t('reset')}
    </ButtonIcon>
  );
};
